import React, { useState } from 'react';
import {
  Progress,
  Box,
  ButtonGroup,
  Button,
  Heading,
  Flex,
  FormControl,
  GridItem,
  FormLabel,
  HStack,
  Input,
  Select,
  SimpleGrid,
  InputLeftAddon,
  InputGroup,
  Textarea,
  FormHelperText,
  InputRightElement,
  useBreakpointValue,
  Grid,
  FormErrorMessage,
} from '@chakra-ui/react';

import { useToast } from '@chakra-ui/react';
import axios from 'axios';

import { validatePercentage, validateSchoolName } from './Validation';

const Form3 = (props) => {
  const [school12, setSchool12] = useState('');
  const [school10, setSchool10] = useState('');
  const [startC10, setStartC10] = useState(new Date());
  const [endC10, setEndC10] = useState(new Date());
  const [startC12, setStartC12] = useState(new Date());
  const [endC12, setEndC12] = useState(new Date());
  const [board10, setBoard10] = useState('');
  const [board12, setBoard12] = useState('');
  const [stream12, setStream12] = useState('');
  const [aggregate12, setAggregate12] = useState('');
  const [aggregate10, setAggregate10] = useState('');

  // for validations
  const [percentageError12, setPercentageError12] = useState('');
  const [percentageError10, setPercentageError10] = useState('');
  const [schoolNameError12, setSchoolNameError12] = useState('');

  const [startDateError12, setStartDateError12] = useState('');
  const [endDateError12, setEndDateError12] = useState('');
  const [startDateError10, setStartDateError10] = useState('');
  const [endDateError10, setEndDateError10] = useState('');

  const toast = useToast();

  const handleNext = () => {
    if (!school12 || !school10) {
      toast({
        title: 'Validation Error',
        description: 'Please fill in all required fields.',
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
      return;
    }

    if (percentageError12 || percentageError10) {
      toast({
        title: 'Validation Error',
        description: 'Please correct the errors in the form.',
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
      return; // Prevent submission if there are validation errors
    }

    const formData = {
      school10: school10,
      school12: school12,
      startC10: startC10,
      startC12: startC12,
      endC10: endC10,
      endC12: endC12,
      board10: board10,
      board12: board12,
      stream12: stream12,
      aggregate10: aggregate10,
      aggregate12: aggregate12,
    };
    axios
      .post(
        'https://glb-api.onrender.com/student/form3',
        { formData: formData },
        { withCredentials: true },
      )
      .then((res) => {
        console.log('sent successfully' + JSON.stringify(formData));
      })
      .catch((err) => {
        console.log(err);
      });
    // props.onNext();
  };

  const handleBack = () => {
    // Handle form submission
    // ...
    // Call the OnBack callback from props to update the step state
    props.OnBack();
  };

  const gridTemplateColumns = useBreakpointValue({
    base: '1fr',
    md: '1fr 1fr',
  });

  const handlePercentageChange12 = (e) => {
    const value = e.target.value;
    setAggregate12(value);

    // Validate percentage using the imported function
    const error = validatePercentage(value);
    setPercentageError12(error);
  };

  // Validation function for Class 10th Score
  const handlePercentageChange10 = (e) => {
    const value = e.target.value;
    setAggregate10(value);

    // Validate percentage using the imported function
    const error = validatePercentage(value);
    setPercentageError10(error);
  };

  const handleSchoolNameChange12 = (e) => {
    const value = e.target.value;
    setSchool12(value);

    // Validate school name length using the imported function
    const error = validateSchoolName(value);
    setSchoolNameError12(error);
    console.log('Value:', value);
    console.log('Error:', error);
  };

  const handleStartDateChange12 = (e) => {
    const value = new Date(e.target.value);
    setStartC12(value);

    // Validate start date and end date for Class 12th
    if (value > endC12) {
      setStartDateError12('Start date cannot be greater than end date');
      setEndDateError12('');
    } else {
      setStartDateError12('');
      setEndDateError12('');
    }
  };

  // Validation function for Class 12th End Date
  const handleEndDateChange12 = (e) => {
    const value = new Date(e.target.value);
    setEndC12(value);

    // Validate start date and end date for Class 12th
    if (value < startC12) {
      setEndDateError12('End date cannot be less than start date');
      setStartDateError12('');
    } else {
      setEndDateError12('');
      setStartDateError12('');
    }
  };

  return (
    <>
      <Box px="150px">
        <Heading w="100%" textAlign={'center'} fontSize="3xl" mb="4%">
          Class 12th and 10th Details
        </Heading>
        <SimpleGrid columns={1} spacing={6}>
          <FormControl mr="5%" size="sm" isRequired>
            <FormLabel
              color="gray.700"
              _dark={{
                color: 'gray.50',
              }}
            >
              Class 12th or Equivalent Degree Certificate
            </FormLabel>
            <Select
              id="certificate"
              name="certificate"
              autoComplete="certificate"
              placeholder="Select option"
              focusBorderColor="brand.400"
              borderColor="transparent"
              boxShadow="md"
              w="full"
              rounded="md"
            >
              <option>Class 12th</option>
              <option>Diploma</option>
            </Select>
          </FormControl>

          <FormControl
            id="school"
            mt={1}
            isRequired
            isInvalid={!!schoolNameError12}
          >
            <FormLabel
              color="gray.700"
              _dark={{
                color: 'gray.50',
              }}
            >
              School
            </FormLabel>
            <Input
              id="School"
              borderColor="transparent"
              boxShadow="md"
              placeholder="School name"
              focusBorderColor="brand.400"
              value={school12}
              onChange={handleSchoolNameChange12}
            />
            {schoolNameError12 && (
              <FormErrorMessage color="red.500">
                {schoolNameError12}
              </FormErrorMessage>
            )}
          </FormControl>
          <Flex>
            <FormControl mr="5%" size="sm">
              <FormLabel htmlFor="first-name">Board</FormLabel>
              <Select
                id="board"
                name="board"
                autoComplete="board"
                placeholder="Select option"
                focusBorderColor="brand.400"
                borderColor="transparent"
                boxShadow="md"
                w="full"
                rounded="md"
              >
                <option>State board</option>
                <option>CBSE</option>
                <option>Central board</option>
              </Select>
            </FormControl>

            <FormControl mr="5%">
              <FormLabel htmlFor="middle-name">Education Type</FormLabel>
              <Select
                id="type"
                name="type"
                autoComplete="type"
                placeholder="Select option"
                borderColor="transparent"
                boxShadow="md"
                w="full"
                rounded="md"
              >
                <option>Full Time</option>
                <option>Private</option>
              </Select>
            </FormControl>
          </Flex>
          <FormControl mr="5%">
            <Flex>
              <FormControl mr="5%" isRequired isInvalid={!!percentageError12}>
                <FormLabel htmlFor="first-name">Score</FormLabel>
                <FormHelperText color="gray.500" fontSize="10px">
                  In case of grades/marks, please enter the equivalent
                  percentage
                </FormHelperText>
                <Input
                  id="Score"
                  placeholder="Score"
                  borderColor="transparent"
                  borderColor={!!percentageError12 ? 'red.300' : 'transparent'}
                  boxShadow="md"
                  value={aggregate12}
                  onChange={handlePercentageChange12}
                />
                {percentageError12 && (
                  <FormErrorMessage color="red.500">
                    {percentageError12}
                  </FormErrorMessage>
                )}
              </FormControl>

              <FormControl mr="5%">
                <FormLabel htmlFor="middle-name">Score Type</FormLabel>
                <FormHelperText color="gray.500" fontSize="10px">
                  Select score type
                </FormHelperText>
                <Select
                  id="type"
                  name="type"
                  autoComplete="type"
                  placeholder="Select option"
                  borderColor="transparent"
                  boxShadow="md"
                  w="full"
                  rounded="md"
                >
                  <option>Percentage</option>
                  <option>CGPA</option>
                </Select>
              </FormControl>
            </Flex>
          </FormControl>

          <FormControl id="school" mt={1} isRequired>
            <FormLabel
              _dark={{
                color: 'gray.50',
              }}
            >
              Branch/Specialization
            </FormLabel>
            <Select
              id="branch"
              name="branch"
              autoComplete="branch"
              placeholder="Select option"
              borderColor="transparent"
              boxShadow="md"
              w="full"
              rounded="md"
            >
              <option>Science</option>
              <option>Commerce</option>
              <option>Arts</option>
              <option>Others</option>
            </Select>
          </FormControl>

          {/* <HStack  spacing={'0px'}>
          <FormControl width={'xl'} size="sm">
            <FormLabel htmlFor="DOB" fontSize="md" fontWeight={'thin'}>
              Duration
            </FormLabel>
            <Flex >

            <Input
              fontSize="xl"
              width={'md'}
              placeholder="Select DOB"
              focusBorderColor="brand.400"
              size="md"
              type="date"

            />
            <Input
              mt={"10.5%"}
              fontSize="xl"
              width={'md'}
              placeholder="Select DOB"
              focusBorderColor="brand.400"
              size="md"
              type="date"

            />

            </Flex>

          </FormControl>

          <FormControl width={'xl'} size="sm">


          </FormControl>
        </HStack> */}

          <Grid templateColumns={gridTemplateColumns} gap={4}>
            <Box>
              <FormControl id="startDate">
                <FormLabel>Start Date</FormLabel>
                <Input
                  type="date"
                  borderColor="transparent"
                  boxShadow="md"
                  value={startC12}
                  onChange={handleStartDateChange12}
                  // onChange={(e) => {
                  //   setStartC12(e.target.value);
                  // }}
                />
                {startDateError12 && (
                  <FormErrorMessage color="red.500">
                    {startDateError12}
                  </FormErrorMessage>
                )}
              </FormControl>
            </Box>
            <Box>
              <FormControl id="endDate">
                <FormLabel>End Date</FormLabel>
                <Input
                  type="date"
                  borderColor="transparent"
                  boxShadow="md"
                  value={endC12}
                  onChange={(e) => {
                    setEndC12(e.target.value);
                  }}
                />
              </FormControl>
            </Box>
          </Grid>
        </SimpleGrid>

        <Heading padding={'50px'} w="100%" textAlign={'center'} fontSize="3xl">
          Class 10th Details
        </Heading>
        <SimpleGrid columns={1} spacing={6}>
          <FormControl id="school" mt={1} w="full" isRequired>
            <FormLabel
              _dark={{
                color: 'gray.50',
              }}
            >
              School
            </FormLabel>
            <Input
              id="School"
              isRequired
              placeholder="School name"
              borderColor="transparent"
              boxShadow="md"
              w="full"
              value={school10}
              onChange={(e) => {
                setSchool10(e.target.value);
                console.log(school10);
              }}
            />
          </FormControl>
          <Flex>
            <FormControl mr="5%" size="sm">
              <FormLabel htmlFor="first-name">Board</FormLabel>
              <Select
                id="board"
                name="board"
                autoComplete="board"
                placeholder="Select option"
                borderColor="transparent"
                boxShadow="md"
                w="full"
                rounded="md"
              >
                <option>State board</option>
                <option>CBSE</option>
                <option>Central board</option>
              </Select>
            </FormControl>

            <FormControl mr="5%" size="sm">
              <FormLabel htmlFor="middle-name">Education Type</FormLabel>
              <Select
                id="type"
                name="type"
                autoComplete="type"
                placeholder="Select option"
                borderColor="transparent"
                boxShadow="md"
                w="full"
                rounded="md"
              >
                <option>Full Time</option>
                <option>Private</option>
              </Select>
            </FormControl>
          </Flex>
          <FormControl mr="5%" isRequired>
            <Flex>
              <FormControl mr="5%">
                <FormLabel htmlFor="first-name">Score</FormLabel>
                <FormHelperText color="gray.500" fontSize="10px">
                  In case of grades/marks, please enter the percentage
                  equivalent of the obtained grade/marks
                </FormHelperText>
                <Input
                  id="Score"
                  placeholder="Score"
                  borderColor="transparent"
                  boxShadow="md"
                  value={aggregate10}
                  isRequired
                  onChange={(e) => {
                    setAggregate10(e.target.value);
                    console.log(aggregate10);
                  }}
                />
              </FormControl>

              <FormControl mr="5%" isRequired>
                <FormLabel htmlFor="middle-name">Score Type</FormLabel>
                <FormHelperText color="gray.500" fontSize="10px">
                  Select score type
                </FormHelperText>
                <Select
                  id="type"
                  name="type"
                  isRequired
                  autoComplete="type"
                  placeholder="Select option"
                  borderColor="transparent"
                  boxShadow="md"
                  w="full"
                  rounded="md"
                >
                  <option>Percentage</option>
                  <option>CGPA</option>
                </Select>
              </FormControl>
            </Flex>
          </FormControl>

          {/* <FormControl id="school" mt={1}>
          <FormLabel
            fontSize="md"
            fontWeight={"thin"}
            color="gray.700"
            _dark={{
              color: "gray.50",
            }}
          >
            Branch/Specialization
          </FormLabel>
          <Select
                id="branch"
                name="branch"
                autoComplete="branch"
                placeholder="Select option"
                focusBorderColor="brand.400"
                shadow="sm"
                size="sm"
                w="full"
                rounded="md"
              >
                <option>Science</option>
                <option>Commerce</option>
                <option>Arts</option>
                <option>Others</option>
              </Select>
        </FormControl> */}

          {/* <HStack spacing={'0px'}>
          <FormControl width={'xl'} size="sm">
            <FormLabel htmlFor="DOB" fontSize="md" fontWeight={'thin'}>
              Duration
            </FormLabel>
            <Input
              fontSize="xl"
              width={'md'}
              placeholder="Select DOB"
              focusBorderColor="brand.400"
              size="md"
              type="date"

            />
          </FormControl>

          <FormControl width={'xl'} size="sm">

            <Input
              fontSize="xl"
              width={'md'}
              placeholder="Select DOB"
              focusBorderColor="brand.400"
              size="md"
              type="date"
              mt={"10.5%"}

            />
          </FormControl>
        </HStack> */}
          <Grid templateColumns={gridTemplateColumns} gap={4}>
            <Box>
              <FormControl id="startDate">
                <FormLabel>Start Date</FormLabel>
                <Input
                  type="date"
                  borderColor="transparent"
                  boxShadow="md"
                  value={startC10}
                  onChange={(e) => {
                    setStartC10(e.target.value);
                  }}
                />
              </FormControl>
            </Box>
            <Box>
              <FormControl id="endDate">
                <FormLabel>End Date</FormLabel>
                <Input
                  type="date"
                  borderColor="transparent"
                  boxShadow="md"
                  value={endC10}
                  onChange={(e) => {
                    setEndC10(e.target.value);
                  }}
                />
              </FormControl>
            </Box>
          </Grid>
        </SimpleGrid>
        {/* <Box mt={"40px"}>
      <Button
          w="7rem"
          height="3rem"
          fontSize="2xl"
          marginRight="5"

          onClick={handleNext}
          colorScheme="blue"
          variant="outline"
        >
          Next
        </Button>

        <Button
          w="7rem"
          height="3rem"
          fontSize="2xl"

          onClick={handleBack}
          colorScheme="blue"
          variant="outline"
        >
          back
        </Button>
        </Box> */}

        <Button mt="40px" colorScheme="blue" onClick={handleNext}>
          Submit
        </Button>
      </Box>
    </>
  );
};

export default Form3;
